import React from 'react';
import { Tabs } from '@features/Tabs';
import AchRelationshipsPage from '@pages/AchRelationshipsPage';
import PaymentRequestsPage from '@pages/PaymentRequestsPage';
import { FC, ReactElement } from 'react';
import { ISOReportsTable } from '@widgets/ISOReportsTable';
import { BmoTransactionsTable } from '@widgets/BmoTransacitonsTable';
import { ReserveComputationTable } from '@widgets/ReserveComputationTable';

interface ITabsContent {
    [key: string]: ReactElement;
}

const tabsContent: ITabsContent = {
    Transfers: <PaymentRequestsPage />,
    'Bank Accounts': <AchRelationshipsPage />,
    'ISO Reports': <ISOReportsTable />,
    Transactions: <BmoTransactionsTable />,
    'Reserve Computation': <ReserveComputationTable />,
};

export const ClearingBankTabs: FC = () => {
    return (
        <Tabs
            initialTab='Transfers'
            tabsContent={tabsContent}
        />
    );
};
